import React from "react";
import { graphql } from "gatsby";
import { css } from "@emotion/react";
import Layout from "../components/Layout";
import SEO from "../components/Seo";

export default function PostTemplate({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data; // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark;
  return (
    <Layout>
      <SEO title={frontmatter.title} />
      <div className="blog-post" css={css``}>
        <h1>{frontmatter.title}</h1>
        <p
          css={css`
            font-size: var(--scale-p1);
            font-family: var(--font-display);
            margin-top: var(--scale-p2);
            margin-bottom: var(--scale-p2);
            max-width: 25em;
          `}
        >
          {frontmatter.description}
        </p>
        <p
          css={css`
            margin-top: var(--scale-p2);
            margin-bottom: var(--scale-p3);
          `}
        >
          {frontmatter.company}, {frontmatter.timePeriod}
        </p>
        <article
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </Layout>
  );
}
export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        company
        timePeriod
        description
        path
        title
      }
    }
  }
`;
